export default __webpack_public_path__ + "static/media/add-img-icon.d243c676.svg";